import { METRIC_UNIT_SYSTEM, UNIT_SYSTEM_TYPE } from 'context'
import { addMilliseconds, differenceInMilliseconds, endOfDay, startOfDay } from 'date-fns'
import { EMPTY_EVENTS_TAG_KEY } from 'screens/UserDetails/Graph/constants'
import { IGraphDataPoint } from 'screens/UserDetails/Graph/types'

const imperialData = [
  106, 110, 102, 105, 106, 99, 97, 99.5, 100.5, 105.5, 97, 95, 98, 98, 94, 113, 105, 117, 99.5, 109,
  98, 96.5, 99, 99, 98.5, 107, 97.5, 104, 102.5, 100, 104, 100, 104.5, 103, 104, 95, 95, 94, 93,
  94.5, 93, 97, 96, 108, 98
]

const metricData = [
  6.625, 6.875, 6.375, 6.5625, 6.625, 6.1875, 6.0625, 6.21875, 6.28125, 6.59375, 6.0625, 5.9375,
  6.125, 6.125, 5.875, 7.0625, 6.5625, 7.3125, 6.21875, 6.8125, 6.125, 6.03125, 6.1875, 6.1875,
  6.15625, 6.6875, 6.09375, 6.5, 6.40625, 6.25, 6.5, 6.25, 6.53125, 6.4375, 6.5, 5.9375, 5.9375,
  5.875, 5.8125, 5.90625, 5.8125, 6.0625, 6, 6.75, 6.125
]

export const getDefaultGraphData = (
  startDate: string,
  endDate: string,
  unitSystem: UNIT_SYSTEM_TYPE
): IGraphDataPoint[] => {
  const dataSet = unitSystem === METRIC_UNIT_SYSTEM ? metricData : imperialData
  const start = startOfDay(new Date(startDate))
  const end = endOfDay(new Date(endDate))
  const offset = differenceInMilliseconds(end, start) / dataSet.length
  const getDate = (index: number) => addMilliseconds(start, offset * index).getTime()

  return Array.from({ length: dataSet.length }, (_, i) => {
    return { time: getDate(i), value: dataSet[i], tag: EMPTY_EVENTS_TAG_KEY }
  })
}
